import { comments } from "@core/gql-mockups/comments";
import { minimize_str } from "@core/helpers/string";

export const CREATE_COMMENT = minimize_str(`
  mutation ($input: CreateCommentInput){
    result: createComment (input: $input)
      ${comments}
  }
`);

export const REPLY_COMMENT = minimize_str(`
  mutation ($input: ReplyCommentInput){
    result: replyComment (input: $input)
      ${comments}
  }
`);
export const ADD_TO_USEFUL_COMMENTS = minimize_str(`
  mutation ($comment_id: ID, $useful: Int){
    result: addToUsefulComments (comment_id: $comment_id, useful: $useful){
      success
}
  }
`);

// soft delete of the user's own unconfirmed comment, question or reply
export const DELETE_COMMENT = minimize_str(`
  mutation ($id: ID!) {
    result: deleteComment(id: $id) {
      success
      message
    }
  }
`);
